<template>
  <a-form
      ref="formRef"
      :model="formData"
      name="password"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
      class="settings-form"
  >
    <a-form-item label="原密码" name="oldPassword">
      <a-input-password v-model:value="formData.oldPassword" placeholder="请输入原密码" />
    </a-form-item>
    <a-form-item label="新密码" name="newPassword">
      <password-input v-model:value="formData.newPassword" placeholder="请输入新密码" />
    </a-form-item>
    <a-form-item label="确认新密码" name="confirmPassword">
      <password-input v-model:value="formData.confirmPassword" placeholder="请再次输入新密码" />
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
      <a-button type="primary" @click="handleSave">保存</a-button>
      <a-button style="margin-left: 10px" @click="handleClose">关闭</a-button>
    </a-form-item>
  </a-form>
</template>

<script setup>
import { ref, reactive } from "vue";
import { message } from "ant-design-vue";
import PasswordInput from '@/components/PasswordInput';
import { updateUserPwd } from '@/api/system/user';
import { useRouter } from 'vue-router';
const router = useRouter();

const formRef = ref();
const formData = reactive({
  oldPassword: '',
  newPassword: '',
  confirmPassword: ''
});

const rules = {
  oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
  newPassword: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, max: 20, message: '密码长度应在6-20位之间', trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: '请确认新密码', trigger: 'blur' },
    {
      validator: (rule, value) => {
        if (!value || value === formData.newPassword) {
          return Promise.resolve();
        }
        return Promise.reject('两次输入的密码不一致');
      },
      trigger: 'blur'
    }
  ]
};

// 保存密码设置
const handleSave = () => {
  formRef.value.validate().then(() => {
    // 这里调用API修改密码
    updateUserPwd(formData.oldPassword, formData.newPassword).then(response => {
          message.success('密码修改成功');
    });
    handleReset();
  }).catch(error => {
    console.log('表单验证失败:', error);
  });
};

const handleClose = () => {
  router.back()
}
</script>

<style lang="less" scoped>
.settings-form {
  .ant-form-item {
    margin-bottom: 24px;
  }

  .ant-form-item-label > label {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #1d2129 !important;
  }

  .ant-input,
  .ant-input-password,
  .ant-select-selector {
    width: 50% !important;
  }

  :deep(.password-input-wrapper) {
    width: 50% !important;
    .password-input-container {
      width: 100% !important;
      .password-input {
        width: 100% !important;
      }
    }
  }
}
</style>